import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QuarterlyResultResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId: number | null;
  year: number;
  quarter: number;
};

const getManagerQuarterlyResult = async ({ managerId, year, quarter }: Params) => {
  const { data } = await api.get<QuarterlyResultResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/result/quarterly`,
    {
      params: { year, quarter },
    }
  );

  return data;
};

export const useGetManagerQuarterlyResult = ({
  managerId,
  year,
  quarter,
}: Params): UseQueryResult<QuarterlyResultResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.QUARTERLY_RESULT, managerId, year, quarter],
    queryFn: () => {
      return getManagerQuarterlyResult({ managerId, year, quarter });
    },
    enabled: managerId !== null,
  });
};
